import Vue from 'vue';
import App from './App.vue';
import store from './store/store';
import VTooltip from 'v-tooltip'
import { ValidationProvider,ValidationObserver, extend } from 'vee-validate';
import { required } from 'vee-validate/dist/rules';
import './assets/app.scss';
import vueCountryRegionSelect from 'vue-country-region-select'


Vue.use(vueCountryRegionSelect)
Vue.use(VTooltip, {
  defaultTrigger: window.innerWidth > 768 ? 'hover focus click' : 'click'
})


extend('required', {
  ...required,
  message: 'Please enter a {_field_}'
});
Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);

Vue.filter('intToDecimalPrice', int => '$' + (int / 100).toFixed(2));

Vue.filter('moneySaleFormat', (price) => {
  if (price) {
    return `$${price}`;
  }
  return '';
});

Vue.filter('getProductImage', product => (product.featured_image && product.featured_image.url) ? product.featured_image.src : '');


/* eslint-disable no-unused-vars */
const EmailShippingApp = new Vue({
  el: '#EmailShipping',
  data: {
  },
  store,
  created() {
    this.$store.dispatch('getCart');
    this.$store.dispatch('getProducts');
    this.$store.dispatch('getFeeProduct');
  },
  render: h => h(App),
});
